// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_38-1";
export var rateTableServiceLevelDropdown = "_38-3";
export var rateTableTypeDropdown = "_38-0";
export var rateTableValueModeDropdown = "_38-2";